declare global {
  const __APP_VERSION__: string;
}

export const getVersionInfo = () => ({
  version: __APP_VERSION__ || 'development',
  buildDate: new Date().toISOString(),
});

export const getVersionString = () => {
  const info = getVersionInfo();
  return info.version;
};
